/* Domovoi · where a product reads and writes its address.

   One interface, two routers. On the web a product's address is the page's
   (History API, so back/forward and shareable URLs work as they always have).
   In the app shell all three products share one page, so each gets an
   in-memory stack of its own: /considered/brand/aesop lives in the Considered
   tab without touching the shell's URL or the other tabs.

   Products never touch window.location or window.history for routing; they
   ask routerFor('<product>'). Side-effect free, so products may import it. */

function split(path) {
  var m = /^([^?#]*)(\?[^#]*)?/.exec(path || '/');
  return { pathname: m[1] || '/', search: m[2] || '' };
}

/* The page's own address. */
export function webRouter() {
  return {
    memory: false,
    get location() {
      return { pathname: window.location.pathname, search: window.location.search, state: window.history.state };
    },
    push: function (path, state) { window.history.pushState(state == null ? null : state, '', path); },
    replace: function (path, state) { window.history.replaceState(state == null ? null : state, '', path); },
    back: function () { window.history.back(); },
    canBack: function () { return window.history.length > 1; },
    /* Called on back/forward, like popstate. Returns an unsubscribe. */
    listen: function (fn) {
      var r = this;
      function on() { fn(r.location); }
      window.addEventListener('popstate', on);
      return function () { window.removeEventListener('popstate', on); };
    },
  };
}

/* A stack in memory, starting at `initial` (e.g. '/considered/brand/aesop?x=1'). */
export function memoryRouter(initial) {
  var stack = [Object.assign(split(initial), { state: null })];
  var listeners = [];
  function top() { return stack[stack.length - 1]; }
  function emit() { var l = top(); listeners.slice().forEach(function (fn) { fn(l); }); }
  return {
    memory: true,
    get location() { var l = top(); return { pathname: l.pathname, search: l.search, state: l.state }; },
    push: function (path, state) { stack.push(Object.assign(split(path), { state: state == null ? null : state })); },
    replace: function (path, state) { stack[stack.length - 1] = Object.assign(split(path), { state: state == null ? null : state }); },
    back: function () { if (stack.length > 1) { stack.pop(); emit(); } },
    canBack: function () { return stack.length > 1; },
    /* Open `path` from outside (a link in another tab, a deep link): push it
       and tell the product, as if the user had navigated there. */
    open: function (path) { stack.push(Object.assign(split(path), { state: null })); emit(); },
    /* Back to the first entry, e.g. tapping the active tab again. */
    reset: function (path) { stack = [Object.assign(split(path || stack[0].pathname + stack[0].search), { state: null })]; emit(); },
    listen: function (fn) {
      listeners.push(fn);
      return function () { listeners = listeners.filter(function (f) { return f !== fn; }); };
    },
  };
}

/* The shell registers one memory router per product before mounting it. The
   table lives on window so other bundles (the feedback sheet) see the same one. */
var registry = typeof window !== 'undefined' ? (window.__dvRouters = window.__dvRouters || {}) : {};
export function setRouterFor(product, router) { registry[product] = router; }
export function routerFor(product) {
  if (!registry[product]) registry[product] = webRouter();
  return registry[product];
}

/* True inside the app shell (shell.html sets data-shell on <html>). */
export function inShell() {
  return typeof document !== 'undefined' && document.documentElement.hasAttribute('data-shell');
}
